<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h2>Events</h2>
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <h5>Add Event</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <form>
          <div class="form-group">
            <label for="txtName">Name</label>
            <input
              type="text"
              class="form-control"
              id="txtName"
              placeholder="Name of the event"
              v-model="alert.name"
            />
          </div>
          <div class="Form-group">
            <label for="txtDescription">Description</label>
            <input
              type="text"
              class="form-control"
              id="txtDescription"
              placeholder="A friendly description of the event"
              v-model="alert.description"
            />
          </div>
          <div class="form-group">
            <label for="ddlDevice">Device</label>
            <select
              class="form-control"
              id="ddlDevice"
              v-model="alert.device_id"
            >
              <option value="null">None</option>
              <option
                v-for="device in filtered_devices"
                :key="device.device_id"
                v-bind:value="device.device_id"
              >
                {{ device.name }}
              </option>
            </select>
            <small class="form-text text-muted"
              >Only relevant if you have a Barionet device.</small
            >
          </div>
          <div class="form-group" v-if="alert.device_id !== null">
            <label for="txtInputNumber">Input</label>
            <input
              type="text"
              class="form-control"
              id="txtInputNumber"
              v-model="alert.input_number"
            />
          </div>
          <div class="form-group">
            <label for="ddlAlertActionType">Action Type</label>
            <select
              class="form-control"
              id="ddlAlertActionType"
              v-model="alert.alert_action_type_id"
            >
              <option value="0">Select..</option>
              <option
                v-for="alert_action_type in filtered_alert_action_types"
                :key="alert_action_type.alert_action_type_id"
                v-bind:value="alert_action_type.alert_action_type_id"
              >
                {{ alert_action_type.name }}
              </option>
            </select>
          </div>
          <ExtensionField
            v-model="alert.extension"
            :helper_text="'Not required, but can only play from web interface if left at 9. If inputted, must keep leading 9 and follow with 3 numbers. Example: 9001'"
          ></ExtensionField>
          <button
            type="button"
            class="btn btn-hub-primary"
            data-toggle="modal"
            data-target="#guidedPrompt"
            @click="submit()"
          >
            Submit
          </button>
          <router-link :to="{ name: 'AlertIndex' }" class="btn btn-secondary"
            >Cancel</router-link
          >
        </form>
      </div>
      <div class="col-4">
        <CurrentExtensions :default_type="'alert'"></CurrentExtensions>
      </div>
    </div>
    <GuidedPrompt
      :passed_state="initial_guided_prompt_state"
      :creation_object="this.alert"
    ></GuidedPrompt>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CurrentExtensions from '../../components/CurrentExtensions'
import ExtensionField from '../../components/ExtensionField'
import GuidedPrompt from '../../components/Alert/GuidedPrompt'

export default {
  data: function () {
    return {
      alert: {
        alert_id: 0,
        device_id: null,
        alert_action_type_id: 3,
        name: '',
        description: '',
        input_number: 1,
        extension: '9',
        enabled: 1
      }
    }
  },
  components: { CurrentExtensions, ExtensionField, GuidedPrompt },
  computed: {
    ...mapGetters({
      devices: 'allDevices',
      alert_action_types: 'allAlertActionTypes',
      guided_states: 'allGuidedStates',
      feature_visual_alert_enabled: 'featureVisualAlertEnabled',
      scoped_site_id: 'scopedSiteId'
    }),
    filtered_devices: function () {
      return this.devices.filter(
        (device) =>
          device.device_type_id === 4 && device.site_id === this.scoped_site_id
      )
    },
    filtered_alert_action_types: function () {
      return this.alert_action_types.filter(
        (alertActionType) => alertActionType.alert_action_type_id !== 2
      )
    },
    initial_guided_prompt_state: function () {
      return this.feature_visual_alert_enabled
        ? this.guided_states.ASK_CREATE_VISUALS
        : this.guided_states.ASK_CREATE_STEPS
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getDevices')
    this.$store.dispatch('getAlertActionTypes')
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX')
  }
}
</script>

<style scoped>
</style>
